import React from "react"
import styled from "styled-components"
import DatePicker from "./DatePicker"
import { getColor, colors } from "../../../../components/Color"
import { media } from "../../../../components/mediaStylesNew"
import moment from "moment"
import { get } from "lodash"
import { Icon } from "antd"

const InputWrapper = styled.div`
  display: flex;
  position: relative;
  border: 1px solid ${getColor("primary", 0.6)};
  border-radius: 4px;
  max-width: 100%;
  margin-bottom: ${props => (!props.renderedOnce ? "150px" : "0px")};
  align-items: center;
  max-width: 400px;
`

const Prefix = styled.div`
  padding-left: 10px;
`
const Suffix = styled.div`
  position: absolute;
  right: 10px;
`

const Reset = styled.div`
  position: absolute;
  right: 40px;

  &:hover {
    cursor: pointer;
    color: ${getColor("secondary", 0.9)};
  }
`

const DateInput = styled.div`
  padding-left: 10px !important;
`

const PartialInput = styled.input`
  width: ${props => props.width * 1.65 || props.maxLength * 16}px;
  border: none;
  font-family: GT America, sans-serif;
  font-size: 16px;
  padding-left: 3px;
  height: 42px;
  pointer-events: none;
  background: ${colors.paleBeige};

  &:focus {
    outline: none;
  }

  &:first-child {
    padding-left: 4px;
  }

  ${media.small`
      width: ${props => props.width * 1.25 || props.maxLength * 11}px;
      &:first-child {
        padding-left: 0px;
      }
  `}
`

export default class DateInputField extends React.Component {
  state = {
    showDatePicker: false,
    renderedOnce: false,
    month: "",
    day: "",
    year: "",
  }

  constructor(props) {
    super(props)
    moment.locale("de")
    let initialDate = {}
    initialDate.day = this.props.value
      ? this.pad(moment(this.props.value).date())
      : this.state.day
    initialDate.month = this.props.value
      ? this.pad(moment(this.props.value).month() + 1)
      : this.state.month
    initialDate.year = this.props.value
      ? this.pad(moment(this.props.value).year())
      : this.state.year
    this.state = {
      ...this.state,
      ...initialDate,
    }
  }

  componentDidMount() {
    if (!this.state.renderedOnce) {
      this.setState({ renderedOnce: true })
    }
  }

  pad(num, size = 2) {
    if (isNaN(num)) {
      return ""
    }
    var s = num + ""
    if (s.indexOf(0) > -1 || s.length === 0) return num
    while (s.length < size) s = "0" + s
    return s
  }

  onChange(event, stateTarget, min, max, picker, transform = v => v) {
    let newValue = event.target.value

    if (isNaN(newValue) && newValue.length > 0) {
      return
    }
    if (min !== undefined) {
      newValue = isNaN(parseInt(newValue))
        ? ""
        : Math.max(min, parseInt(newValue))
    }
    if (max !== undefined) {
      newValue = isNaN(parseInt(newValue))
        ? ""
        : Math.min(max, parseInt(newValue))
    }

    if (!isNaN(newValue)) {
      this.setState({ [stateTarget]: newValue }, () => {
        if (parseInt(newValue) > 0 && this.datePicker) {
          this.datePicker.scrollToPoint(
            picker,
            transform(this.state[stateTarget])
          )
        }
        this.props.onChange(
          moment.utc({
            year: this.state.year,
            date: this.state.day,
            month: this.state.month - 1,
          })
        )
      })
    }
  }

  reset = event => {
    event.stopPropagation()
    this.setState({
      day: "",
      month: "",
      year: "",
      showDatePicker: false,
    })
    this.props.onChange("")
  }

  focus() {
    try {
      this.dayInput.focus()
    } catch (err) {
      console.error("Dayinput can not be focused")
    }
  }

  correctInput(stateTarget) {
    this.setState({
      [stateTarget]: this.pad(this.state[stateTarget]),
    })
  }

  render() {
    return (
      <InputWrapper
        onClick={() => {
          this.setState({ showDatePicker: true })
          if (typeof window !== `undefined` && window.innerWidth > 575) {
            this.dayInput.focus()
          }
        }}
        showDialog={this.state.showDatePicker}
        renderedOnce={this.state.renderedOnce}
      >
        <Prefix>{this.props.prefix}</Prefix>
        <DateInput>
          <PartialInput
            maxLength={2}
            placeholder="DD"
            width={24}
            value={this.state.day || ""}
            onChange={event =>
              this.onChange(
                event,
                "day",
                0,
                31,
                get(this.datePicker, "dayPicker")
              )
            }
            onBlur={() => this.correctInput("day")}
            ref={dayInput => (this.dayInput = dayInput)}
          />
          {". "}
          <PartialInput
            maxLength={2}
            placeholder="MM"
            width={28}
            value={this.state.month}
            onChange={event =>
              this.onChange(
                event,
                "month",
                0,
                12,
                get(this.datePicker, "monthPicker"),
                value => moment.months()[value - 1]
              )
            }
            onBlur={() => this.correctInput("month")}
          />
          {".  "}
          <PartialInput
            maxLength={4}
            placeholder="YYYY"
            value={this.state.year}
            onChange={event =>
              this.onChange(
                event,
                "year",
                0,
                2025,
                get(this.datePicker, "yearPicker")
              )
            }
            onBlur={() => this.correctInput("year")}
          />
        </DateInput>
        {(this.state.day || this.state.month || this.state.year) && (
          <Reset onClick={this.reset}>
            <Icon type="close-circle" />
          </Reset>
        )}
        <Suffix>{this.props.suffix}</Suffix>
        {this.state.showDatePicker && (
          <DatePicker
            ref={datePicker => (this.datePicker = datePicker)}
            updateValue={(variable, value) =>
              this.setState({ [variable]: this.pad(value) }, () => {
                this.props.onChange(
                  moment.utc({
                    year: this.state.year,
                    date: this.state.day,
                    month: this.state.month - 1,
                  })
                )
              })
            }
            onClose={(event, { day, month, year }) => {
              event.stopPropagation()
              this.setState(
                {
                  showDatePicker: false,
                  day: this.pad(day),
                  month: this.pad(moment.months().indexOf(month) + 1),
                  year,
                },
                () => {
                  this.props.onChange(
                    moment.utc({
                      year: this.state.year,
                      date: this.state.day,
                      month: this.state.month - 1,
                    })
                  )
                }
              )
            }}
            {...this.state}
          />
        )}
      </InputWrapper>
    )
  }
}
